import { useCallback, useContext, useRef } from 'react';
import { useGetThemeConfig } from '@namespace/themes';
import {
  pauseNotificationAction,
  resumeNotificationAction,
  setErrorNotificationAction,
  setInfoNotificationAction,
  setNotificationAction,
  setSuccessNotificationAction,
  setWarningNotificationAction
} from '../../store/actions';
import { NotificationContext } from '../../store/context';

const useNotifications = () => {
  // change notification timeout to otherSettings?
  const { timeout = 5000 } = useGetThemeConfig('Notification');
  const [{ notificationType, notificationDispatch = () => {} }] =
    useContext(NotificationContext);

  const notificationRef = useRef('');
  notificationRef.current = notificationType;

  return {
    errorNotification: useCallback(
      (data) => notificationDispatch(setErrorNotificationAction(data, timeout)),
      [notificationDispatch]
    ),
    successNotification: useCallback(
      (data) =>
        notificationDispatch(setSuccessNotificationAction(data, timeout)),
      [notificationDispatch]
    ),
    infoNotification: useCallback(
      (data) => notificationDispatch(setInfoNotificationAction(data, timeout)),
      [notificationDispatch]
    ),
    warningNotification: useCallback(
      (data) =>
        notificationDispatch(setWarningNotificationAction(data, timeout)),
      [notificationDispatch]
    ),
    customNotification: useCallback(
      (data) => notificationDispatch(setNotificationAction(data)),
      [notificationDispatch]
    ),
    pauseNotificationFor: useCallback(
      (data) => notificationDispatch(pauseNotificationAction(data)),
      [notificationDispatch]
    ),
    resumeNotificationFor: useCallback(
      (data) => notificationDispatch(resumeNotificationAction(data)),
      [notificationDispatch]
    )
  };
};

export default useNotifications;
